import { ref } from 'vue';
import { defineStore } from 'pinia';

import ApiPaas from '@/api/ApiPaas';
import { datetimeToString } from '@/components/common/dateUtils';
import { useUserStore } from '@/stores/user';

import type {
	PaasCoordRaw,
	PaasStatusResponse,
	PaasTaskRaw,
	PaasTaskStored,
} from '@/api/ApiTypes';


const addPaasStatusData = (item: PaasTaskRaw): PaasTaskStored => ({
	...item,
	createdStr: datetimeToString(item.created),
});


export const usePaasStore = defineStore('paas', () => {
	const userStore = useUserStore();

	const isLoading = ref(true);
	const newTask = ref(false);
	const allowToStart = ref(false);
	const showProgress = ref(false);
	const lastStart = ref<string | null>(null);
	const finishedCount = ref(0);
	const totalCount = ref(0);
	const paasTasks = ref<PaasTaskStored[]>([]);
	const paasCoords = ref<PaasCoordRaw[]>([]);
	const mountpoints = ref<string[]>([]);

	const paasStatusGetHandler = (response: PaasStatusResponse): void => {
		isLoading.value = false;
		newTask.value = response.new_task;
		allowToStart.value = response.current_task.allow_to_start;
		showProgress.value = response.current_task.show_progress;
		lastStart.value = response.current_task.last_start
			? datetimeToString(response.current_task.last_start)
			: null;
		finishedCount.value = response.current_task.finished_count;
		totalCount.value = response.current_task.total_count;
		paasTasks.value = response.previous_tasks.map(addPaasStatusData);
		paasCoords.value = response.coords;
		mountpoints.value = response.mountpoints;
	};

	const updatePaasData = (): void => {
		if (userStore.allowToSeePaas) {
			isLoading.value = true;
			ApiPaas.paasStatusGet(paasStatusGetHandler);
		}
	};

	return {
		isLoading,
		newTask,
		allowToStart,
		showProgress,
		lastStart,
		finishedCount,
		totalCount,
		paasTasks,
		paasCoords,
		mountpoints,
		updatePaasData,
	};
});
